<form
  [formGroup]="scripts_form_group"
  class="sp-column sp-form__standalone sp-padding__x4 sp-width__full">
  <mat-form-field
    class="sp-width__full sp-form-field sp-form-field__primary-light sp-margin__bottom-x2"
    appearance="fill"
    color="accent">
    <mat-label>
      {{ 'Script' | translate }}
    </mat-label>
    <mat-select
      formControlName="script_type"
      [errorStateMatcher]="error_matcher"
      required>
      <mat-option value="update_prepaid_setting">{{ 'Update prepaid' | translate }}</mat-option>
      <mat-option value="update_prepaid_long_setting">{{ 'Update prepaid long' | translate }}</mat-option>
      <mat-option value="update_fourthline_setting">{{ 'Update Fourthline' | translate }}</mat-option>
      <mat-option value="update_sdd_setting">{{ 'Update SDD' | translate }}</mat-option>
    </mat-select>
  </mat-form-field>

  <button
    *ngIf="isCsvUploadVisible()"
    mat-button
    (click)="file_upload.click()"
    class="sp-width__full sp-button__dashed-accent sp-bank-account__height sp-margin__vert-x2">
    <mat-icon matPrefix> upload </mat-icon>
    <span
      *ngIf="!file_name"
      class="sp-color__primary">
      (.csv)
    </span>
    <span
      *ngIf="file_name"
      class="sp-color__primary">
      {{ file_name }}
    </span>
  </button>

  <input
    type="file"
    accept="text/csv"
    class="sp-display__none"
    (change)="onFileLoaded($event)"
    #file_upload />

  <app-shared-button
    class="sp-width__full sp-margin__top-x2"
    [button_class]="'sp-button__main'"
    [spinner_class]="'sp-spinner__main'"
    [cta]="'GENERAL.RUN_SCRIPT_CTA'"
    [icon]="'code'"
    [is_disabled]="!isFormValid() || is_script_create_running || !text_file"
    [is_spinner_visible]="is_script_create_running"
    (click)="onRunClick()"></app-shared-button>
</form>
